export const getServiceClusterEntries = (clusters) => {
  if (!clusters || typeof clusters !== "object" || Array.isArray(clusters)) {
    return [];
  }

  return Object.entries(clusters).filter(([, services]) =>
    Array.isArray(services)
  );
};
